import { useEffect, useState } from 'react';
import { apiCall } from '../utils/apiUtils';

/**
 * Loads users with role "client" for tenant dropdowns.
 * @param {{ enabled?: boolean }} options — set enabled: false to skip fetch (caller supplies clients).
 */
export function useClientUsers(options = {}) {
  const { enabled = true } = options;
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled));

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const response = await apiCall('/api/users');
        const list = Array.isArray(response?.users) ? response.users : [];
        const onlyClients = list.filter((u) => u.role === 'client');
        if (!cancelled) setClients(onlyClients);
      } catch {
        if (!cancelled) setClients([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { clients, loading };
}
